import { useEffect, useState } from 'react';

import styles from './BootScreen.module.css';

const SLOW_AFTER_MS = 8000;

interface Props {
  label?: string;
}

/**
 * Shown while the auth gate resolves the session and the caller's membership.
 *
 * The gates used to render `null` here, so a hung `getSession()` (corrupt
 * localStorage, network stall) produced an indefinitely blank white page that
 * was indistinguishable from a broken deploy. After SLOW_AFTER_MS we say so
 * and offer a reload rather than spinning forever in silence.
 */
export function BootScreen({ label = 'טוען…' }: Props) {
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => { setSlow(true); }, SLOW_AFTER_MS);
    return () => { clearTimeout(timer); };
  }, []);

  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      <div className={styles.inner}>
        <div className={styles.spinner} aria-hidden="true" />
        <p className={styles.label}>{label}</p>
        {slow ? (
          <p className={styles.slow}>
            זה לוקח יותר מהצפוי. אם המסך לא מתקדם — רענן את הדף.
          </p>
        ) : null}
      </div>
    </div>
  );
}
